<template>
  <div class="main-page mediation">
    <Menus
      title="人民调解"
      :home="true"
    >
      <a
        slot="left-link"
        href="javascript:void(0)"
        @click="getPrev"
      ></a>
    </Menus>
    <div class="container-flex">
      <div class="mediationcon">
        <Step
          :steplist="steplist"
          :type="step"
          :stepitemwidth="'4rem'"
        />
        <template v-if="step==1">
          <!-- 申请人信息 -->
          <div class="node lp-question">
            <input
              type="hidden"
              name="node"
              value
            />
            <div class="lp-question--title">
              <strong>申请人信息</strong>
            </div>
            <!-- 申请人姓名 -->
            <div class="cells-form">
              <div class="lp-question-form">
                <div class="cells-title requild">姓名</div>
                <div class="cells-bd">
                  <div>
                    <input
                      v-model="sqrname"
                      type="text"
                      placeholder="请填写姓名"
                      class="lp-question-input"
                    />
                  </div>
                  <div class="errinfo">{{ errinfo.sqrname }}</div>
                </div>
              </div>
              <!-- 申请人身份证号码-->
              <div class="lp-question-form">
                <div class="cells-title requild">身份证号码</div>
                <div class="cells-bd">
                  <div>
                    <input
                      v-model="sqridcard"
                      type="text"
                      maxlength="18"
                      placeholder="请填写身份证号码"
                      class="lp-question-input"
                    />
                  </div>
                  <div class="errinfo">{{ errinfo.sqrname }}</div>
                </div>
              </div>
              <!-- 申请人 性别-->
              <div class="lp-question-form">
                <div class="cells-title requild">性别</div>
                <div class="cells-bd">
                  <div class="lp-question-widget-select">
                    <div
                      v-for="(item,ii) in sex"
                      :key="'key-'+ii"
                      class="lp-question-widget-select_item"
                      :class="{'checked': sqrsex == item.gender}"
                      @click="setSex(item)"
                    >
                      <div class="cells-check__icon" />
                      <div class="cells-check__title">{{ item.title }}</div>
                    </div>
                  </div>
                  <div class="errinfo">{{ errinfo.sqrsex }}</div>
                </div>
              </div>
              <!-- 申请人 民族-->
              <div class="lp-question-form">
                <div class="cells-title requild">民族</div>
                <div class="cells-bd">
                  <select
                    v-model="sqrnationalitycode"
                    class="lp-question-input"
                  >
                    <option style="display:none;color:#999">请选择民族</option>
                    <option
                      v-for="(item,index) in nations"
                      :key="'key-'+index"
                      :value="item.code"
                    >{{ item.value }}</option>
                  </select>
                  <div class="errinfo">{{ errinfo.sqrnationa }}</div>
                </div>
              </div>
              <!-- 申请人 生日-->
              <div class="lp-question-form">
                <div class="cells-title requild">生日</div>
                <div class="cells-bd">
                  <date-picker
                    v-model="sqrbrithday"
                    not-before
                    :clearable="false"
                    width="100%"
                    input-class="lp-question-input birthday"
                    :popup-style="position"
                    placeholder="请选择出生日期"
                    :first-day-of-week="1"
                  />
                  <div class="errinfo">{{ errinfo.sqrbrithday }}</div>
                </div>
              </div>
              <!-- 所在区域 -->
              <div class="lp-question-form">
                <div class="cells-title requild">居住地：</div>
                <div class="cells-bd">
                  <div>
                    <input
                      type="text"
                      :value="sqraddress"
                      readonly="readonly"
                      @click="setAtArea(false)"
                      placeholder="请填写住所区域"
                      class="lp-question-input"
                    />
                  </div>
                  <div class="errinfo">{{ errinfo.sqraddress }}</div>
                </div>
              </div>
              <div class="lp-question-form">
                <div class="cells-title">详细地址:</div>
                <div class="cells-bd">
                  <div>
                    <input
                      type="text"
                      v-model="sqrotheraddress"
                      placeholder="请补充详细地址"
                      class="lp-question-input"
                    />
                  </div>
                </div>
              </div>
              <!-- 申请人手机号码 -->
              <div class="lp-question-form">
                <div class="cells-title requild">电话</div>
                <div class="cells-bd">
                  <div>
                    <input
                      v-model="sqrphone"
                      type="tel"
                      pattern="^[1][3,4,5,6,7,8,9][0-9]{9}"
                      placeholder="请输入真实电话号码"
                      class="lp-question-input"
                    />
                  </div>
                  <div class="errinfo">{{ errinfo.sqrphone }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 被申请人信息 -->
          <div class="node lp-question">
            <input
              type="hidden"
              name="node"
              value
            />
            <div class="lp-question--title">
              <strong>被申请人信息</strong>
            </div>
            <!-- 被申请人姓名 -->
            <div class="cells-form">
              <div class="lp-question-form">
                <div class="cells-title requild">姓名</div>
                <div class="cells-bd">
                  <div>
                    <input
                      v-model="bsqrname"
                      type="text"
                      placeholder="请填写姓名"
                      class="lp-question-input"
                    />
                  </div>
                </div>
                <div class="errinfo">{{ errinfo.bsqrname }}</div>
              </div>
              <!-- 被申请人 身份证号码-->
              <div class="lp-question-form">
                <div class="cells-title">身份证号码</div>
                <div class="cells-bd">
                  <div>
                    <input
                      type="text"
                      pattern="[0-9Xx]*"
                      maxlength="18"
                      :value="bsqridcard"
                      placeholder="请填写身份证号码"
                      class="lp-question-input"
                    />
                  </div>
                </div>
              </div>
              <!-- 被申请人 性别-->
              <div class="lp-question-form">
                <div class="cells-title">性别</div>
                <div class="cells-bd">
                  <div class="lp-question-widget-select">
                    <div
                      v-for="(item,ii) in sex"
                      :key="'key-'+ii"
                      class="lp-question-widget-select_item"
                      :class="{'checked': bsqrsex == item.gender}"
                      @click="setSex(item,true)"
                    >
                      <div class="cells-check__icon" />
                      <div class="cells-check__title">{{ item.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 被申请人 民族-->
              <div class="lp-question-form">
                <div class="cells-title">民族</div>
                <div class="cells-bd">
                  <div>
                    <select
                      v-model="bsqrnationalitycode"
                      class="lp-question-input"
                    >
                      <option style="display: none;color:#999;">请选择民族</option>
                      <option
                        v-for="(item,index) in nations"
                        :key="'key-'+index"
                        :value="item.code"
                      >{{ item.value }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- 被申请人 生日-->
              <div class="lp-question-form">
                <div class="cells-title">生日</div>
                <div class="cells-bd">
                  <date-picker
                    v-model="bsqrbrithday"
                    not-before
                    :clearable="false"
                    width="100%"
                    input-class="lp-question-input birthday"
                    :popup-style="position"
                    placeholder="请选择出生日期"
                    :first-day-of-week="1"
                  />
                </div>
              </div>
              <!-- 所在区域 -->
              <div class="lp-question-form">
                <div class="cells-title">居住地：</div>
                <div class="cells-bd">
                  <div>
                    <input
                      type="text"
                      :value="bsqraddress"
                      placeholder="请填写住所区域"
                      readonly="readonly"
                      @click="setAtArea(true)"
                      class="lp-question-input"
                    />
                  </div>
                </div>
              </div>
              <div class="lp-question-form">
                <div class="cells-title">详细地址:</div>
                <div class="cells-bd">
                  <div>
                    <input
                      type="text"
                      v-model="bsqrotheraddress"
                      placeholder="请补充详细地址"
                      class="lp-question-input"
                    />
                  </div>
                </div>
              </div>
              <!-- 被申请人手机号码 -->
              <div class="lp-question-form">
                <div class="cells-title">电话</div>
                <div class="cells-bd">
                  <div>
                    <input
                      v-model="bsqrphone"
                      type="tel"
                      pattern="^[1][3,4,5,6,7,8,9][0-9]{9}"
                      placeholder="请输入真实电话号码"
                      class="lp-question-input"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="node lp-question">
            <input
              type="hidden"
              name="node"
              value
            />
            <div class="lp-question--title">
              <strong>纠纷发生地</strong>
            </div>
            <!-- 纠纷发生地-->
            <div class="cells lp-question-text">
              <div class="lp-question-form jflevel">
                <div class="cells-title requild">地区</div>
                <div class="cells-bd">
                  <input
                    type="text"
                    class="lp-question-input"
                    :value="jiufenaddress"
                    readonly="readonly"
                    @click="setJiuArea"
                    placeholder="请选择地区"
                  />
                </div>
              </div>
            </div>
            <!-- 纠纷发生地： -->
            <div class="cells lp-question-text">
              <div class="lp-question-form jflevel">
                <div class="cells-title requild">街道：</div>
                <div class="cells-bd">
                  <select
                    v-model="currentstreet"
                    @change="setStreet"
                    class="lp-question-input"
                  >
                    <option
                      value
                      style="display: none;color:#333;"
                    >请选择街道</option>
                    <option
                      v-for="(item,key) in street"
                      :key="'key-'+key"
                      :value="item.dqbm"
                    >{{ item.dqmc }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <!-- 纠纷信息  -->
          <div class="node lp-question">
            <input
              type="hidden"
              name="node"
              value
            />
            <div class="lp-question--title">
              <strong>纠纷类型与描述</strong>
            </div>
            <!-- 纠纷类型-->
            <div class="cells lp-question-text">
              <div class="lp-question-form jflevel">
                <div class="cells-title requild">纠纷类型</div>
                <div class="cells-bd">
                  <select
                    v-model="jftype"
                    class="lp-question-input"
                  >
                    <option
                      value
                      style="display: none;color:rgba(255,255,255,0.2)"
                    >请选择纠纷类型</option>
                    <option
                      v-for="(item,key) in jftypes"
                      :key="'key-'+key"
                      :value="item.id"
                    >{{ item.text }}</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- 纠纷描述 -->
            <div class="cells lp-question-text">
              <div class="lp-question-form jflevel">
                <div class="cells-title requild">纠纷描述</div>
                <div class="cells-bd">
                  <textarea
                    v-model="jflcontent"
                    maxlength="200"
                    class="jflevelcontent"
                    rows="5"
                    placeholder="请输入纠纷原因"
                  />
                  <div class="cells-bd-counter">
                    <span>{{ jflcontent.length }}</span>/200
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="step==2">
          <div class="organ">
            <div class="organcon">
              <div class="title">请选择纠纷发生地的调委会（必选）</div>
              <div
                v-if="groupList.length"
                class="committee"
              >
                <div class="organ-item-panel">
                  <div class="organ-title">调解机构</div>
                  <div
                    v-for="(item,index) in groupList"
                    :key="'key--'+index"
                    class="organ-item"
                    :class="[item.twhpk ===groupSelect?'active':'']"
                    @click="setGrop(item.twhpk)"
                  >
                    <div class="name">{{ item.twhmc }}</div>
                    <div class="tel">电话：{{ item.lxdh }}</div>
                  </div>
                </div>
                <div class="organ-item-panel">
                  <div class="organ-title">行专调解机构</div>
                  <div
                    v-for="(item,index) in hzlist"
                    :key="'key--'+index"
                    class="organ-item"
                    :class="[item.twhpk ===groupSelect?'active':'']"
                    @click="setGrop(item.twhpk)"
                  >
                    <div class="name">{{ item.twhmc }}</div>
                    <div class="tel">电话：{{ item.lxdh }}</div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="ridio-info"
              >
                <i class="glyphicon glyphicon-exclamation-sign" />
                <br />当前地区暂无调解机构
              </div>
            </div>
          </div>
        </template>
        <template v-if="step==3">
          <div class="success-con">
            <div class="success-info">
              <div class="success-icon" />
              <div class="title">申请调解完成</div>
              <div class="desc">
                工作日请保持你的手机畅通，等待工作人员与你联系。
                <br />办理过程可在"人民调解-进度查询"中进行查询；或者扫描下面二维码关注"云南掌上123
                <br />48"公众号，在"我的-人民调解中"进行查询。
              </div>
              <img
                id="erweima"
                src
                alt
                class="erweima"
              />
              <div class="info">使用微信扫一扫，关注”云南掌上12348”</div>
              <a
                class="button"
                @click="$router.push('/')"
              >返回</a>
            </div>
          </div>
        </template>
        <div
          v-if="step!=3"
          class="save"
          @click="getNext"
        >提交保存</div>
      </div>
    </div>
    <Alert
      v-if="alert.show"
      :info="alert.info"
      :recall="alert.recall"
      @setClose="value=>alert.show=value"
    />
    <Areaselect
      :areaselect="areaselect"
      @getClose="areaselect.show=false;isjiufen=false"
      @update="chooseArea"
      v-if="areaselect.show"
    ></Areaselect>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import jftypes from '../../datas/js/jftype.json'
import Step from '@/components/FayuanStep'
import { nations } from '../../datas/js/config.js'
import idCard from 'idcard'
import Alert from '@/components/Alert'
import Areaselect from '../../components/Areaselect'
export default {
  components: {
    Menus,
    Step,
    Alert,
    Areaselect
  },
  data () {
    return {
      steplist: ['1.填写基本信息', '2.选择受理机构', '3.完成申请'],
      sex: [{ title: '男', gender: 1 }, { title: '女', gender: 2 }],
      step: 1,
      jftypes, // 纠纷类型
      nations, // 民族
      sqrname: '', // strY申请人姓名
      sqrsex: '', // intY性别，1男，2女
      sqridcard: '', // strY申请人身份证号
      sqrbrithday: '', // strY申请人生日，格式：2018-01-01
      sqraddress: '', // strY申请人地址
      sqrotheraddress: '', // 申请人详细地址
      sqrphone: '', // strY申请人电话
      sqrnationalitycode: '', // strY申请人民族代码
      bsqrname: '', // strY
      bsqrsex: '', // intY
      bsqridcard: '', // str Y
      bsqrbrithday: '', // str Y
      bsqraddress: '', // str Y
      bsqrotheraddress: '', // 被申请人详细地址
      bsqrphone: '', // str Y
      bsqrnationalitycode: '', // str Y
      jflcontent: '', // strY纠纷详情
      jftype: '', // strY纠纷类别，按照国标代码
      startaptime: '', // strY预约时间段开始时间
      endaptime: '', // strY预约时间段结束时间
      twhpk: '', // 案件pk
      userid: '', // 用户id
      position: {
        left: 0
      },
      jiufenaddress: '',
      isjiufen: false,
      errinfo: {
        sqrname: '',
        sidCard: '',
        bsidCard: '',
        sidPhone: '',
        bsidPhone: ''
      },
      alert: {
        show: false,
        info: '',
        recall: () => { }
      },
      currentcity: [],
      currentcode: '', // 当前区code
      currentstreet: '',
      street: [], // 街道
      groupList: [],
      hzlist: [],
      groupSelect: '',
      isbsArea: 0, // 选择地区是否是被申请人地区， 1 是被申请人， 2 申请人
      areaselect: {
        show: false,
        showchild: false
      }
    }
  },
  computed: {
    machineuuid () {
      return this.$store.state.device.point.no || ''
    }
  },
  watch: {
    jflcontent () {
      this.jflcontent = this.jflcontent.replace(/\s+/g, '')
    },
    sqridcard () {
      this.sqridcard = this.sqridcard.replace(/\s+/g, '')
      let reg = /[\u4e00-\u9fa5]/
      for (let char of this.sqridcard) {
        if (reg.test(char)) {
          this.sqridcard = this.sqridcard.replace(char, '')
        }
      }
    },
    bsqridcard () {
      this.bsqridcard = this.bsqridcard.replace(/\s+/g, '')
      let reg = /[\u4e00-\u9fa5]/
      for (let char of this.bsqridcard) {
        if (reg.test(char)) {
          this.bsqridcard = this.bsqridcard.replace(char, '')
        }
      }
    },
    sqrphone () {
      let reg = /^[0-9]*$/
      for (let char of this.sqrphone) {
        if (!reg.test(char)) {
          this.sqrphone = this.sqrphone.replace(char, '')
        }
      }
    },
    bsqrphone () {
      let reg = /^[0-9]*$/
      for (let char of this.bsqrphone) {
        if (!reg.test(char)) {
          this.bsqrphone = this.bsqrphone.replace(char, '')
        }
      }
    }
  },
  mounted () {
    this.userid = this.$store.state.user.wechatUinfo.userid // 微信uid
    if (!this.userid) {
      this.$router.goBack()
    }
    const citycode = this.$store.state.device.config.web_code
    const area = this.$store.state.device.areajson[0].children
    for (let i in area) {
      if (Number(area[i].code) === Number(citycode)) {
        this.currentcity = area[i].children
      }
    }
    const wechatUinfo = this.$store.state.user.wechatUinfo
    if (wechatUinfo.mobile) {
      this.sqrphone = wechatUinfo.mobile // 电话
    }
    if (wechatUinfo.idcard) {
      this.checkIdCard(wechatUinfo.idcard)
    }
  },
  methods: {
    setGrop (twhpk) {
      this.groupSelect = twhpk
      this.twhpk = twhpk
    },
    getDate (num) {
      let days = new Date()
      let n = 0
      if (num) {
        n = 24 * 60 * 60 * 1000 * num
      }
      days.setTime(days.getTime() + n)
      let month =
        days.getMonth() + 1 > 9
          ? days.getMonth() + 1
          : '0' + (days.getMonth() + 1)
      let day = days.getDate() > 9 ? days.getDate() : '0' + days.getDate()
      return days.getFullYear() + '-' + month + '-' + day
    },
    setSex (item, isbs) {
      const value = item.gender
      if (isbs) {
        this.bsqrsex = value
      } else {
        this.sqrsex = value
      }
    },
    checkIdCard (e, type = false, isbs) {
      const value = type ? e.target.value : e
      const cardInfo = idCard.info(value)
      if (!cardInfo.valid) {
        if (isbs) {
          this.errinfo.bsidCard = '身份证号格式错误'
        } else {
          this.errinfo.sidCard = '身份证号格式错误'
        }
        return
      }
      this.errinfo.sidCard = ''
      this.errinfo.bsidCard = ''
      let gender = cardInfo.gender === 'M' ? 1 : 2
      let bd = cardInfo.birthday.toString()
      bd = `${bd.slice(0, 4)}-${bd.slice(4, 6)}-${bd.slice(6)}`
      if (isbs) {
        //  为true是被申请人
        this.bsqrsex = gender
        this.bsqrbrithday = bd
        this.bsqridcard = value
      } else {
        this.sqrsex = gender
        this.sqrbrithday = bd
        this.sqridcard = value
      }
    },
    getPrev () {
      this.groupSelect = ''
      this.twhpk = ''
      if (this.step < 2) {
        // this.$router.back(-1)
        this.$router.goBack()
        return
      }
      if (this.step === 3) {
        this.$router.push('/')
      }
      this.step--
    },
    getBrithday (d) {
      let days = new Date(d)
      let month =
        days.getMonth() + 1 > 9
          ? days.getMonth() + 1
          : '0' + (days.getMonth() + 1)
      let day = days.getDate() > 9 ? days.getDate() : '0' + days.getDate()
      return days.getFullYear() + '-' + month + '-' + day
    },
    async getNext () {
      if (this.step > 2) {
        return
      }
      if (this.step === 1 && !this.checkData(1)) {
        return
      }
      if (this.step === 2 && !this.checkData(2)) {
        return
      }
      this.step++
      $('.container-flex') //eslint-disable-line
        .stop()
        .animate({ scrollTop: 0 }, 'normal')
      console.log(this.step, 'ss')
      if (this.step === 3) {
        $.post('https://yn.12348.laway.cn/api/get/wechat/qrcode/', { 'querystr': `userid=${this.userid}` }, function (data) { // eslint-disable-line
          console.log(data.msg)
          if (data.status === 1) {
            var qrcodeurl = data.result.qrcode_url
            $('#erweima').attr('src', qrcodeurl) // eslint-disable-line
          }
        })
      }
      $(".container-flex").scrollTop(0, 2000); // eslint-disable-line
    },
    checkData (step) {
      if (step === 1) {
        let msg = '请填写'
        if (!this.sqrname) {
          msg += '申请人姓名，'
        }
        if (!this.sqridcard) {
          msg += '申请人身份证号，'
        }
        if (!this.sqrbrithday) {
          msg += '申请人生日，'
        }
        if (!this.sqrbrithday) {
          msg += '申请人生日，'
        }
        if (!this.sqraddress) {
          msg += '申请人地址，'
        }
        if (!this.sqrphone) {
          msg += '申请人电话，'
        }
        if (!this.sqrnationalitycode) {
          msg += '申请人民族，'
        }
        if (!this.bsqrname) {
          msg += '被申请人姓名， '
        }
        if (!this.jiufenaddress) {
          msg += '纠纷发生地所属地区， '
        }
        if (!this.currentstreet) {
          msg += '纠纷发生地所属街道， '
        }
        if (!this.jftype) {
          msg += '纠纷类型'
        }
        if (!this.jftype) {
          msg += '纠纷描述'
        }
        if (
          !this.sqrname ||
          !this.sqridcard ||
          !this.sqrbrithday ||
          !this.sqraddress ||
          !this.sqrphone ||
          !this.sqrnationalitycode ||
          !this.bsqrname ||
          !this.jftype ||
          !this.jflcontent ||
          !this.jiufenaddress ||
          !this.currentstreet
        ) {
          this.alert.show = true
          this.alert.info = msg
          return false
        }
      }
      if (step === 2) {
        if (!this.twhpk) {
          this.alert.show = true
          this.alert.info = '请选择受理机构'
          return false
        } else {
          this.setApply()
        }
      }
      return true
    },
    async setApply () {
      if (!this.userid) {
        this.$router.goBack()
      }
      this.bsqrsex = this.bsqrsex ? this.bsqrsex : 1
      this.bsqrbrithday = this.bsqrbrithday ? this.bsqrbrithday : '1990-01-01'
      this.sqraddress += this.sqrotheraddress
      this.bsqraddress += this.bsqrotheraddress
      const data = {
        input_source: 11,
        user_id: this.userid,
        sqrname: this.sqrname, // strY申请人姓名
        sqrsex: Number(this.sqrsex), // intY性别，1男，2女
        sqridcard: this.sqridcard, // strY申请人身份证号
        sqrbrithday: this.sqrbrithday, // strY申请人生日，格式：2018-01-01
        sqraddress: this.sqraddress, // strY申请人地址
        sqrphone: this.sqrphone, // strY申请人电话
        sqrnationalitycode: this.sqrnationalitycode, // strY申请人民族代码
        bsqrname: this.bsqrname, // strY
        bsqrsex: Number(this.bsqrsex), // intY
        bsqridcard: this.bsqridcard, // str Y
        bsqrbrithday: this.bsqrbrithday, // str Y
        bsqraddress: this.bsqraddress, // str Y
        bsqrphone: this.bsqrphone, // str Y
        bsqrnationalitycode: this.bsqrnationalitycode, // str Y
        content: this.jflcontent, // strY纠纷详情
        jftype: this.jftype, // strY纠纷类别，按照国标代码
        startaptime: this.getDate(), // strY预约时间段开始时间
        endaptime: this.getDate(3), // strY预约时间段结束时间
        twhpk: this.twhpk,
        machine_uuid: this.machineuuid
      }
      const { msg, status, results } = await this.$post(
        'https://yn.12348.laway.cn/api/mediate/set/',
        { ...data }, '', '', true
      )
      if (!status) {
        console.log(msg)
        return false
      }
      localStorage.pk = results.pk
    },
    setJiuArea () {
      this.street = []
      this.groupList = []
      this.groupSelect = ''
      this.currentstreet = ''
      this.isjiufen = true
      this.isbsArea = 0
      this.twhpk = ''
      this.areaselect = {
        show: true,
        showchild: true
      }
    },
    setStreet (item) {
      this.groupList = []
      this.groupSelect = ''
      this.getGroupList()
    },
    chooseArea (value) {
      const adress = `云南省-${value[0].label}-${value[1].label}`
      if (this.step === 1) {
        if (this.isbsArea === 1) {
          this.bsqraddress = adress
        }
        if (this.isbsArea === 2) {
          this.sqraddress = adress
        }
        if (this.isjiufen) {
          this.jiufenaddress = adress
          this.street = []
          this.currentcode = value[1].code
          this.groupList = []
          this.groupSelect = ''
          this.getStreetList(this.currentcode)
        }
      }
      if (this.step === 2) {
        this.currentcity = value[0].children
        this.jiufenaddress = adress
        this.street = []
        this.groupList = []
        this.groupSelect = ''
      }
    },
    // 选择用户地址
    async getStreetList (code) {
      const { status, msg, results } = await this.$get(
        `https://yn.12348.laway.cn/api/mediate/area/${code}/`
      )
      if (!status) {
        console.log(msg)
        return
      }
      this.groupList = []
      if (results.data.length) {
        this.street = results.data
      }
    },
    async getGroupList () {
      this.twhpk = ''
      this.groupList = []
      this.hzlist = []
      this.groupSelect = ''
      if (!this.currentstreet) {
        return
      }
      const res = await this.$get(
        `https://yn.12348.laway.cn/api/mediate/get/twh/${this.currentstreet}/`
      )
      if (!res.status) {
        return
      }
      this.groupList = res.results.data
      this.hzlist = res.results.hz_data
      console.log(this.groupList, 'this.groupList')
    },
    // 选择住址地区
    setAtArea (isbs) {
      if (isbs) {
        this.isbsArea = 1
      } else {
        this.isbsArea = 2
      }
      this.areaselect = {
        show: true,
        showchild: true
      }
    }
  }
}
</script>

<style lang="stylus">
.mediation
  .mx-input-append
    display none
  .fy-step
    margin-bottom 0.1rem
  .mediationcon
    padding-top 0.6rem
  .lp-question-form
    .cells-title
      width 1.57rem !important
  input:-ms-input-placeholder, textarea::-webkit-input-placeholder
    color rgba(255, 255, 255, 0.5)
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder
    color rgba(255, 255, 255, 0.5)
  textarea.jflevelcontent
    display flex
    box-sizing border-box
    width 100%
    height 4rem
    border 0
    background-color rgba(255, 255, 255, 0.2)
    border 0
    border-radius 0.1rem
    outline none
    padding 0.2rem
    box-sizing border-box
  .lp-question-form
    &.jflevel
      align-items flex-start
      .cells-title
        margin 0.3rem 0
  .lp-question
    .errinfo
      position absolute
      bottom -0.1rem
      color #ec3839
      font-size 0.2rem
  select
    position relative
    option
      color #333
      width 100%
  input.birthday
    font-size 0.3rem
    color #fff
  .organ
    position relative
    .organcon
      width 12rem
      margin 0.3rem auto
      padding 0.5rem 0.3rem 0.5rem 0.4rem
      border-radius 0.3rem
      border solid 1px rgba(255, 255, 255, 0.2)
      .title
        font-size 0.34rem
        color #fff
        line-height 0.4rem
        margin-bottom 0.1rem
        &.street
          margin-top 0.5rem
      .arealist, .committee
        display flex
        flex-wrap wrap
        .area-item
          width 2.6rem
          height 0.9rem
          color #333
          font-size 0.3rem
          margin 0 0.1rem 0.2rem 0.1rem
          text-align center
          line-height 0.9rem
          border 1px solid #e6e6e6
          border-radius 0.1rem
          &.active
            background-color #fc9d0b
            color #fff
          &.other
            background none
            font-size 0.3rem
            color #ffb23c
        .organ-title
          color #fff
          padding 0.2rem 0.1rem 0.3rem 0.1rem
          font-size 0.28rem
        .organ-item
          position relative
          width 5.38rem
          color #333
          font-size 0.3rem
          margin 0 0.1rem 0.2rem 0.1rem
          background #fff
          border 1px solid #e6e6e6
          border-radius 0.1rem
          padding 0.15rem 0.2rem
          box-sizing border-box
          overflow hidden
          .name
            line-height 2
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
          .adress, .tel
            font-size 0.24rem
            line-height 0.26rem
          .adress
            margin-bottom 0.15rem
          &.active
            background-color #fc9d0b
            border-color #fc9d0b
            color #fff
            &:before
              content ''
              position absolute
              top 0
              right 0
              width 0
              height 0
              border-style solid
              border-width 0 0.84rem 0.84rem 0
              border-color transparent #f57900 transparent transparent
            &::after
              content ''
              position absolute
              top 0.15rem
              right 0.15rem
              width 0.1rem
              height 0.2rem
              border-right 2px solid #fff
              border-bottom 2px solid #fff
              transform rotate(40deg)
  .ridio-info
    padding 0.3rem 0
    font-size 0.3rem
    text-align center
    color #999
    i
      font-size 0.5rem
      margin-bottom 0.2rem
  .success-con
    width 12rem
    border-radius 0.3rem
    padding 0.5rem 0
    margin 0.3rem auto
    background rgba(255, 255, 255, 0.2)
    border solid 1px rgba(255, 255, 255, 0.2)
  .save
    width 12rem
    margin 0.6rem auto
    height 0.96rem
    background-color #fc9d0b
    border-radius 0.1rem
    color #fff
    text-align center
    font-size 0.32rem
    line-height 0.96rem
</style>
